import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './styles/extension-blocker.css'
import './utils/error-handler'
import { installDomMutationGuard } from './utils/dom-mutation-guard'
import { initErrorTracking } from './observability/error-tracking'

// Immune ai DOM-mutator delle estensioni browser (crash removeChild sui portal
// Radix). Deve girare prima di qualsiasi render React.
installDomMutationGuard()

// Task #2604 — Error tracking (GlitchTip). No-op se VITE_ERROR_TRACKING_DSN vuoto.
initErrorTracking()

// La pagina pubblica embeddabile del widget chatbot (`/chatbot/widget/:agentId`)
// è renderizzata dentro l'iframe dello snippet d'embed su siti esterni: il
// visitatore non è autenticato e non deve attivare i side-effect dell'app
// (incluso il Service Worker della PWA). Tutte le altre rotte lo registrano.
const isPublicChatbotWidget = /^\/chatbot\/widget\//.test(window.location.pathname);

if ('serviceWorker' in navigator && !isPublicChatbotWidget) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('[SW] Service Worker registered:', registration.scope);
      })
      .catch((error) => {
        console.error('[SW] Service Worker registration failed:', error);
      });
  });
}

const rootEl = document.getElementById('root')
if (!rootEl) throw new Error('Root element #root not found in index.html')
ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
